import { IFilters } from '../components/interfaces';

export const filterParams = {
    duplicateFilter: <IFilters>{
        filterParameterName: 'duplicates',
        filterValue: 1,
    },
};
